export default "__VITE_ASSET__CsneWAFn__"